function BikeDefaultValueRequestTransformer(Util, jsonMapper, userInputRepository) {

	function formatDateAndTimeTheGuidewireWay(date, time) {
		var format = "{0} at {1} AEST" ;
		var timeFormatted = '4:00PM' ;
		if ( time )
			timeFormatted = moment().tz("Australia/Sydney").format('h:mma');
		return Util.stringFormat(format, moment().tz("Australia/Sydney").format('Do MMM YYYY') , timeFormatted) ;
	}

	var staticValuesMapping = {
		quoteType:'Full',
		productCode : 'QPYPersonalMotorcycle',
		paymentFrequency: 'everyyear',
		// "anyClaimsQuestion": "unknown",
		// "anyLostLicencesQuestion": "unknown",
		// "anyConvictionsQuestion": "unknown",
		// "anyInfringementsQuestion": "no",

		"motorcycles.0.bikeUsage" : "bike",
		"motorcycles.0.damage": "no_damage",
		"motorcycles.0.isMemberOfClub": false,
		// is the main rider the registered owner of the bike
		"motorcycles.0.isTheMainRider": true,
		"motorcycles.0.motorCycleUsage": "private",
		"motorcycles.0.isFinanced": false,
		"motorcycles.0.isBikeModified": false,
		"motorcycles.0.businessUsage": "courier",
		"motorcycles.0.garageType": "communal_garage",
		"motorcycles.0.motorcycleClub": "other",
		"motorcycles.0.sumInsuredType": "market",
		"motorcycles.0.motorCycleKilometers": "4001_8000km",
		"motorcycles.0.isAccessoriesAdded": false,
		"motorcycles.0.coverType": "comprehensive",
		"motorcycles.0.accessoriesPrice": 0,
		"motorcycles.0.totalModificationsPrice": 0,
		"motorcycles.0.totalAccessoriesPrice": 0,
		"motorcycles.0.accountLocation.addressType": "postal",


		// "motorcycles.0.financeType": "none",
		"motorcycles.0.sumInsuredAmount": "1000",
		// "motorcycles.0.riders.*.person.primaryAddress.addressType": "residential",

		"motorcycles.0.riders.*.licensedToRide": "yes",
		"motorcycles.0.riders.*.rider.currentInsurer": "nocurrentinsurance",
		"motorcycles.0.riders.*.rider.yearsLicenced": "1",
		"motorcycles.0.riders.*.rider.licenceType": "full",
		"motorcycles.0.riders.*.rider.relationWithMainRider": "other",
		"motorcycles.0.riders.*.rider.noClaimBonus": "nil",
		// "motorcycles.0.riders.*.rider.visaType": "distinguishedtalentvisa124",
		"motorcycles.0.riders.*.rider.person.gender": "male",
		"motorcycles.0.riders.*.rider.person.firstName": "An@n",
		"motorcycles.0.riders.*.rider.person.lastName": "An@nym@us",
		"motorcycles.0.riders.*.rider.person.contactType": "person",
		"motorcycles.0.riders.*.rider.person.dateOfBirth": "01/06/2000",
		"policyHolders.*.contact.primaryAddress.addressType": "residential",


		// "email": "a@a.com",
		"motorcycles.0.availableCoverTypes" : [
			"comprehensive",
			"fireandtheft",
			"thirdpartyonly",
			"thirdpartyfiretheft"
        ],
		"motorcycles.0.availableSumInsuredTypes": [
          "market",
          "agreed"
        ],


		"motorcycles.0.excess.ageExcess" : 0,
		"motorcycles.0.excess.flexiExcessExcess" : 0,
		// "motorcycles.0.excess.flexiExcessOptions": [],
		"motorcycles.0.excess.inexperiencedRiderExcess" : 0,
		"motorcycles.0.excess.riderTrainingExcess" : 0,
		"motorcycles.0.excess.standardExcess" : 0,
		"motorcycles.0.excess.theftClaimsExcess" : 0,
		"motorcycles.0.excess.unListedRiderExcess" : 0,

		"policyHolders.0.mainHolder": true,
		"policyHolders.0.contact.contactType": "person",
		"policyHolders.0.contact.firstName": "An@n",
		"policyHolders.0.contact.lastName": "An@nym@us",
		"policyHolders.0.contact.dateOfBirth": "01/06/2000",
		"policyHolders.0.contact.primaryPhone": "mobile",
		// full quote transformation :
        "status" : "Draft",
        "documentDeliveryMethod": 'email',
		"displayStatus": 'Draft',
		"periodStartDateTimeAEDT": formatDateAndTimeTheGuidewireWay(moment(), moment()),
		"periodEndDateTimeAEDT" : formatDateAndTimeTheGuidewireWay(moment().add(1,'years')),
		"channel": 'portal',
		"motorcycles.0.riders.*.riderUsage" : "other"
	}

	function transform(intermediateRequest, userInput) {
		var transformedRequest = jsonMapper.setDefault(userInput, staticValuesMapping) ;
		return transformedRequest;
	}

	return {
		transform: transform
	}
}
